// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bono-section-icon {
  padding: 7px;
  border: 1px solid black;
  border-radius: 25px;
  margin: 5px;
  font-size: 1.5rem;
}
.bono-section-icon.available {
  border-color: var(--ion-color-success);
  background-color: var(--ion-color-success);
  color: var(--ion-color-success-contrast);
}
.bono-section-icon.validated {
  border-color: var(--ion-color-medium);
  background-color: var(--ion-color-medium);
  color: var(--ion-color-medium-contrast);
}

.title {
  font-size: 1.5rem;
  color: var(--ion-color-primary);
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/modal/ticket-bono-details/ticket-bono-details.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AACJ;AAAI;EACI,sCAAA;EACA,0CAAA;EACA,wCAAA;AAER;AAAI;EACI,qCAAA;EACA,yCAAA;EACA,uCAAA;AAER;;AACA;EACI,iBAAA;EACA,+BAAA;EACA,kBAAA;AAEJ","sourcesContent":[".bono-section-icon{\r\n    padding: 7px;\r\n    border: 1px solid black;\r\n    border-radius: 25px;\r\n    margin: 5px;\r\n    font-size: 1.5rem;\r\n    &.available{\r\n        border-color: var(--ion-color-success);\r\n        background-color: var(--ion-color-success);\r\n        color: var(--ion-color-success-contrast);\r\n    }\r\n    &.validated{\r\n        border-color: var(--ion-color-medium);\r\n        background-color: var(--ion-color-medium);\r\n        color: var(--ion-color-medium-contrast);\r\n    }\r\n}\r\n.title{\r\n    font-size: 1.5rem;\r\n    color: var(--ion-color-primary);\r\n    margin-bottom: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
